export const Footer = () => {
  return (
    <footer className="mb-10 mt-10">
      <p>a drop from <a
        className="decorate"
        href="https://verses.xyz/"
        target="_blank" rel="noreferrer">verses</a></p>
    </footer>
  )
}